import { ButtonUnstyled, useResponsiveDropdown } from '@sketch/components'
import { ReactComponent as Ellipsis } from '@sketch/icons/ellipsis-17'
import React from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { MenuLink } from './MenuLink'
import { useDrop, ShareDropPayload } from '@sketch/modules-common'

const ProjectOptionsButton = styled(ButtonUnstyled)`
  display: inline-flex;
  color: currentColor;

  justify-content: center;
  align-items: center;

  padding: 5px; /* stylelint-disable-line scales/space */

  &:focus {
    color: ${({ theme }) => theme.colors.foreground.secondary.D};
  }
`

const StyledEllipsis = styled(Ellipsis)`
  width: 17px;
  height: 17px;
`

export interface ActionableMenuLinkProps {
  icon: ({ isLinkActive }: { isLinkActive: boolean }) => React.ComponentType
  dropdownContent?: React.ReactNode
  onShareDropped?: (data: ShareDropPayload) => void
  to: string
  text: React.ReactNode
}

const ActionPopoverWrapper: React.FCC = ({ children }) => <div>{children}</div>

export const ActionableMenuLink = (props: ActionableMenuLinkProps) => {
  const { text, to, dropdownContent, icon, onShareDropped } = props
  const location = useLocation()

  const { isDraggedOver, kind, ...dragEvents } = useDrop({ onShareDropped })

  const isLinkActive = location.pathname === to

  const [content, buttonProps, { visible }] = useResponsiveDropdown({
    dropdown: ActionPopoverWrapper,
    dropdownProps: {
      children: dropdownContent,
    },
    placement: 'bottom',
    usePortal: true,
  })

  const dropdown =
    dropdownContent && !isDraggedOver ? (
      <>
        <ProjectOptionsButton data-testid="project-options" {...buttonProps}>
          <StyledEllipsis />
        </ProjectOptionsButton>
        {content}
      </>
    ) : null

  return (
    <MenuLink
      icon={icon({ isLinkActive })}
      to={to}
      $forceHover={visible || isDraggedOver}
      text={text}
      action={dropdown}
      {...dragEvents}
    />
  )
}
